import React, { createContext, useContext, useEffect, useState } from 'react';
import { portalApi, setPortalToken, getPortalToken } from '../lib/portalApi';

const PortalAuthContext = createContext(null);

export const PortalAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = signed out, object = signed in

  const checkAuth = async () => {
    if (!getPortalToken()) {
      setUser(false);
      return;
    }
    try {
      const { data } = await portalApi.get('/portal/auth/me');
      setUser(data);
    } catch {
      setPortalToken(null);
      setUser(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const applySession = (data) => {
    setPortalToken(data.token);
    setUser({ email: data.email, name: data.name, picture: data.picture, client: data.client || null });
  };

  const login = async (email, password) => {
    const { data } = await portalApi.post('/portal/auth/login', { email, password });
    applySession(data);
    return data;
  };

  const signup = async (name, email, password) => {
    const { data } = await portalApi.post('/portal/auth/signup', { name, email, password });
    applySession(data);
    return data;
  };

  const loginWithGoogleSession = async (sessionId) => {
    const { data } = await portalApi.post('/portal/auth/google/session', { session_id: sessionId });
    applySession(data);
    return data;
  };

  const logout = async () => {
    try {
      await portalApi.post('/portal/auth/logout');
    } finally {
      setPortalToken(null);
      setUser(false);
    }
  };

  return (
    <PortalAuthContext.Provider value={{ user, login, signup, loginWithGoogleSession, logout, checkAuth }}>
      {children}
    </PortalAuthContext.Provider>
  );
};

export const usePortalAuth = () => useContext(PortalAuthContext);
